export * from './lib/component-tooltip/component-tooltip.service';
export {
  COMPONENT_TOOLTIP_RESIZE_PROVIDERS,
  ComponentTooltipResizeDispatcher,
} from './lib/component-tooltip/resize-providers';
export { BaseTooltipComponent } from './lib/component-tooltip/base-tooltip.component';
